package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.hardware

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.HorizontalScrollBehavior
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.CashRegisterConfigHeaders
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.CashRegisterConfigHardwareHeaders
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.CashRegisterConfig
import org.hs_soft.runmynesto.pages.components.TabItem
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.hardware.component.eft.EFT
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.hardware.component.hardware_kitchen_location.HardwareKitchenLocations
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.hardware.component.receipt_printer_config.ReceiptPrinterConfig
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun HardwareTabCashRegisterConfig(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
    modifier: Modifier = Modifier,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit,
    cashRegisterConfig: CashRegisterConfig?
)
{
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(Dimen.mediumPadding)
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    ) {
        Column {
            Row(
                modifier = HorizontalScrollBehavior
                    .toModifier()
                    .thenIf(
                        windowSizeMode != WindowSizeModeEnum.PHONE,
                        Modifier.margin(leftRight = Dimen.mediumPadding)
                    )
                    .margin(
                        bottom = Dimen.normalPadding
                    )
                    .weight(1f)
                    .then(
                        if (windowSizeMode == WindowSizeModeEnum.PHONE)
                            Modifier.width(
                                Dimen.mobileTabsWidth
                            )
                        else if (windowSizeMode == WindowSizeModeEnum.TABLET) {
                            Modifier.width(
                                Dimen.tabletTabsSmallWidth
                            )
                        } else Modifier
                    ),
                verticalAlignment = Alignment.CenterVertically
            ) {
                CashRegisterConfigHardwareHeaders.entries.forEach { tab ->
                    TabItem(
                        title = tab.title,
                        isSelected = tab == state.selectedCashRegisterConfigHardwareTab,
                        onTabClick = {
                            event(OptionsEvent.OnCashRegisterConfigHardwareTabClick(tab))
                        },
                        windowSizeMode = windowSizeMode,
                    )
                }
            }
        }

        when (state.selectedCashRegisterConfigHardwareTab) {
            CashRegisterConfigHardwareHeaders.RECEIPT_PRINTER -> {
                ReceiptPrinterConfig(
                    windowSizeMode = windowSizeMode,
                    cashRegisterConfig = cashRegisterConfig,
                    updateCashRegisterConfig = { configsList: List<Pair<String, dynamic>> ->
                        updateCashRegisterConfig(configsList)
                    }
                )
            }

            CashRegisterConfigHardwareHeaders.KITCHEN_STATIONS -> {
                HardwareKitchenLocations(
                    windowSizeMode = windowSizeMode,
                    cashRegisterConfig = cashRegisterConfig,
                    updateCashRegisterConfig = { configsList: List<Pair<String, dynamic>> ->
                        updateCashRegisterConfig(configsList)
                    }
                )
            }

            CashRegisterConfigHardwareHeaders.EFT -> {
                EFT (
                    cashRegisterConfig = cashRegisterConfig,
                    updateCashRegisterConfig = { configsList: List<Pair<String, dynamic>> ->
                        updateCashRegisterConfig(configsList)
                    }
                )
            }

            // TODO TODO
            /*CashRegisterConfigHardwareHeaders.TSE -> {
                TSE(
                    tseLocations = tseLocations,
                    selectedCashRegisterConfigData = selectedCashRegisterConfigData,
                    updateCashRegisterConfig = { title: String, value: dynamic, valueIsInParameters ->
                        updateCashRegisterConfig(title, value, valueIsInParameters, false, emptyList())
                    }
                )
            }*/
        }
    }
}


